import { put, takeEvery } from "redux-saga/effects";
import {
  fetchGraphMethod,
  fetchMethod,
} from "../../../../../services/httpService";
import messagePopup from "../../../../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
  ALL_JUMP_DATA_LIST_START: "ALL_JUMP_DATA_LIST_START",
  ALL_JUMP_DATA_LIST_SUCCESS: "ALL_JUMP_DATA_LIST_SUCCESS",
  ALL_JUMP_DATA_LIST_FAILED: "ALL_JUMP_DATA_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const allJumpDataListStart = (data) => ({
  type: actionType.ALL_JUMP_DATA_LIST_START,
  payload: data,
});

export const allJumpDataListSuccess = (data) => ({
  type: actionType.ALL_JUMP_DATA_LIST_SUCCESS,
  payload: data,
});

export const allJumpDataListFailed = (data) => ({
  type: actionType.ALL_JUMP_DATA_LIST_FAILED,
  payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
  loading: false,
  data: null,
  error: null,
};

export default function allJumpDataListReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case actionType.ALL_JUMP_DATA_LIST_START:
      return {
        ...state,
        loading: true,
      };
    case actionType.ALL_JUMP_DATA_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case actionType.ALL_JUMP_DATA_LIST_FAILED:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return { ...state };
  }
}

// ===================================================== side effect =============================================

export function* allJumpDataListSaga(action) {
  try {
    const response = yield fetchGraphMethod(
      action.payload.query,
      action.payload.variables,
      true
    );
    if (response && response.status === 200) {
      yield put(
        allJumpDataListSuccess({
          allJumpData: response.data.data,
        })
      );
    } else {
      messagePopup("", "Jump Data List failed", "error");
      yield put(allJumpDataListFailed("Jump Data List failed"));
    }
  } catch (error) {
    messagePopup("", "Jump Data List failed", "error");
    yield put(allJumpDataListFailed("Jump Data List failed"));
  }
}

//Watcher
export function* watchAllJumpDataListSaga() {
  yield takeEvery(actionType.ALL_JUMP_DATA_LIST_START, allJumpDataListSaga);
}
